module.exports = __webpack_public_path__ + "img/Show the impact of your work.42eddd64.gif";